module.exports = __webpack_public_path__ + "static/img/MN@3x.c60ffd6c.jpg";